/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

interface Props {
	route: Record<any, any>;
	path?: string;
	roles: Array<string>;
}

const ProtectedRoute: React.FC<Props> = ({ route, roles, path }) => {
	return React.createElement(route.element, { name: route?.name });

	// if (path && AUTH_ROUTES.map(name => name).includes(route?.name)) {
	// 	return <Navigate to={path} />;
	// }
	// return <Navigate to='/login' />;
};

export default ProtectedRoute;
